"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "preganziol": {
    "aa085b37": [{
      "hkey": "0472adfe",
      "slug": "san-trovaso-settecomuni",
      "name": "San Trovaso-Settecomuni",
      "primary": true,
      "skipSearch": false
    }],
    "san-trovaso": [{
      "hkey": "0472adfe",
      "slug": "san-trovaso-settecomuni",
      "name": "San Trovaso-Settecomuni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f64b1dd2": [{
      "hkey": "0472adfe",
      "slug": "san-trovaso-settecomuni",
      "name": "San Trovaso-Settecomuni",
      "primary": true,
      "skipSearch": false
    }],
    "sette-comuni": [{
      "hkey": "0472adfe",
      "slug": "san-trovaso-settecomuni",
      "name": "San Trovaso-Settecomuni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "preganziol"
    }]
  }
};
exports["default"] = _default;